export const CHANGE_CURRENT_PAGE = 'addresses/CHANGE_CURRENT_PAGE'
export const FETCH_ADDRESSES_LIST = 'addresses/FETCH_ADDRESSES_LIST'
